import React from 'react';
import { useIntl } from 'react-intl';
import { Stack } from 'expo-router';
import { useResponsive } from '@sg/garnish';

import { HEADER_SCREEN_OPTIONS } from '../../options';

// ─────────────────────────────────────────────────────────────────────────────

export default function GiftCardsTabLayout() {
  const { formatMessage } = useIntl();
  const { currentBreakpoint } = useResponsive();

  return (
    <Stack screenOptions={HEADER_SCREEN_OPTIONS}>
      <Stack.Screen name="index" options={{ headerShown: false }} />

      <Stack.Screen
        name="checkout/[assetId]/index"
        options={{
          headerShown: currentBreakpoint.isXS,
          title: formatMessage(messages.checkoutTitle),
        }}
      />

      <Stack.Screen
        name="confirmation/[orderId]/index"
        options={{
          headerShown: currentBreakpoint.isXS,
          title: formatMessage(messages.confirmationTitle),
        }}
      />

      <Stack.Screen
        name="redeem/[giftCardId]/index"
        options={{ headerShown: false }}
      />
    </Stack>
  );
}

// ─── Messages ───────────────────────────────────────────────────────────────

const messages = {
  checkoutTitle: {
    id: 'gift-card-checkout-screen.title',
    defaultMessage: 'Customize your gift',
    description: 'Gift Card Checkout Screen | Title',
  },
  confirmationTitle: {
    id: 'gift-card-confirmation-screen.title',
    defaultMessage: 'Order confirmation',
    description: 'Gift Card Confirmation Screen | Title',
  },
} as const;
